/*
 * tp-pv-gate.js — Kauf-Gate fuer 0-%-Artikel nach § 12 Abs. 3 UStG (Plan 0026, IT#16625).
 *
 * Gegenstueck zu snippets/tp-pv-gate.liquid. Der Server rendert Kaufen-Button und
 * Warenkorb-Checkout bereits "disabled data-tp-pv-locked" und den Express-Wrapper
 * mit der Klasse "is-locked" (data-tp-pv-express). Beides bleibt SICHTBAR — nur
 * erkennbar gesperrt (ausgegraut). Erst die angekreuzte Checkbox
 * (data-tp-pv-consent) entsperrt und aktiviert den Hidden-Input mit der
 * Line-Item-Property "Nullsteuersatz-Erklaerung". Fail-closed: ohne JS kein Kauf.
 *
 * Der Sperr-Look haengt am disabled-Attribut bzw. an .is-locked, nicht an einer
 * eigenen JS-Klasse — nimmt der Consent das Attribut weg, ist der Button in einem
 * Rutsch wieder normal. Express bewusst per Klasse statt disabled:
 * ProductDetails._updateButton() (Empire-Chunk) raeumt bei jedem Variantenwechsel
 * disabled-Attribute ab, eine Klasse fasst es nicht an. Gegen dieselbe Stelle
 * sichert zusaetzlich der submit-Guard in der Capture-Phase ab.
 *
 * Klick auf einen gesperrten Button: disabled-Buttons feuern keine Click-Events,
 * und pointer-events:none reicht den Klick an das Elternelement durch. Darum haengt
 * der Shake-Handler auf den umgebenden Zonen (bindZones) und reagiert nur, wenn das
 * Ereignis die Zone selbst trifft — ein Klick auf Mengenfeld o. Ae. hat ein anderes
 * target und loest nichts aus.
 *
 * Zwei Spuren fuer den Nachweis:
 *  - Line-Item-Property an der Position (fuehrend, haengt an der Zeile) und
 *  - Cart-Attribut gleichen Namens an der Bestellung (POST /cart/update.js,
 *    Vorbild assets/tp-attribution.js).
 * Ein Express-Checkout direkt von der Produktseite legt einen eigenen Checkout ohne
 * den Warenkorb an und nimmt Cart-Attribute deshalb moeglicherweise NICHT mit —
 * dort traegt die Line-Item-Property den Nachweis. Auf der Cart-Seite bleibt
 * ebenfalls die Zeilen-Property das Kriterium (Property = Position,
 * Attribut = Bestellung).
 *
 * ABHAENGIGKEIT: assets/tp-condition-property.js. Dort (Z. 19-42) haengt der
 * fetch-Wrapper, der die woertlichen "properties[...]"-Keys im Body von
 * /cart/add.js nach data.properties nestet. Er greift fuer ALLE properties[...]-
 * Keys, also auch fuer unsere — ohne dieses Asset verwirft die Ajax-API die
 * Property. Ladereihenfolge egal (beide defer, der Wrapper greift zur Laufzeit).
 */
(function () {
  'use strict';

  var VERSION_FALLBACK = 'v1';
  var PROPERTY_NAME = 'Nullsteuersatz-Erklärung';
  /* Notbremse, falls /cart/update.js haengt: laenger als das wartet der
     submit-Guard nicht auf das Cart-Attribut. */
  var ATTRIBUTE_TIMEOUT_MS = 1500;

  function version(gate) {
    return gate.getAttribute('data-tp-pv-version') || VERSION_FALLBACK;
  }

  function stamp(gate) {
    return 'Bestätigt ' + version(gate) + ' · ' + new Date().toISOString();
  }

  function mode(gate) {
    return gate.getAttribute('data-tp-pv-mode') || 'product';
  }

  function isActive(gate) {
    return !gate.hasAttribute('hidden');
  }

  function isConsented(gate) {
    var box = gate.querySelector('[data-tp-pv-consent]');
    return !!(box && box.checked);
  }

  function closestForm(el) {
    return el.closest ? el.closest('form') : null;
  }

  function parseJson(el) {
    if (!el) { return null; }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function show(el) {
    if (el) { el.removeAttribute('hidden'); }
  }

  function hide(el) {
    if (el) { el.setAttribute('hidden', ''); }
  }

  function postJson(url, payload) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function shake(gate) {
    gate.classList.remove('is-shake');
    /* Reflow erzwingen, damit die Animation bei wiederholtem Versuch neu startet. */
    void gate.offsetWidth;
    gate.classList.add('is-shake');
    setTimeout(function () { gate.classList.remove('is-shake'); }, 600);
  }

  /* ------------------------------------------------------------ Cart-Attribut */

  /* Setzt (oder raeumt) das Cart-Attribut. Fire-and-forget: der Klick darf daran
     nie haengenbleiben. Solange der Request laeuft, merkt sich das Gate den
     Zustand, damit der submit-Guard den ATC kurz zurueckhalten kann. */
  function sendAttribute(gate, value) {
    if (!window.fetch) { return; }

    var attributes = {};
    attributes[PROPERTY_NAME] = value;

    gate.tpPvAttrPending = true;
    var settled = false;

    function settle() {
      if (settled) { return; }
      settled = true;
      gate.tpPvAttrPending = false;
      var form = gate.tpPvResubmit;
      gate.tpPvResubmit = null;
      if (form) { resubmit(form); }
    }

    setTimeout(settle, ATTRIBUTE_TIMEOUT_MS);

    try {
      postJson('/cart/update.js', { attributes: attributes })
        .then(settle)['catch'](settle);
    } catch (e) {
      settle();
    }
  }

  /* Der Guard hat den Submit abgefangen, waehrend das Attribut unterwegs war —
     jetzt nachholen. requestSubmit() loest denselben submit-Handler aus wie der
     Klick (Ajax-ATC), form.submit() taete das nicht. */
  function resubmit(form) {
    setTimeout(function () {
      try {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } catch (e) { /* dann klickt der Kunde eben erneut — Button ist offen */ }
    }, 0);
  }

  /* ---------------------------------------------------------------- Produkt */

  /* Sperrt/entsperrt alles, was zu diesem Gate gehoert. Der Kaufen-Button wird
     nur angefasst, wenn er das Gate-Merkmal traegt; ein ausverkaufter Button
     (Theme-Klasse "disabled") bleibt in jedem Fall gesperrt. */
  function applyState(gate, form) {
    var active = isActive(gate);
    var consented = isConsented(gate);
    /* Gestempelt wird nur, wenn das Gate fuer die gewaehlte Variante gilt.
       Freigegeben ist, sobald es nicht gilt (Variantenwechsel auf einen
       Nicht-PV-Artikel) oder bestaetigt wurde. */
    var stamped = active && consented;
    var open = !active || consented;

    var prop = form.querySelector('[data-tp-pv-property]');
    if (prop) {
      if (stamped) {
        prop.disabled = false;
        prop.value = stamp(gate);
      } else {
        prop.disabled = true;
        prop.value = '';
      }
    }

    var btn = form.querySelector('[data-tp-pv-locked]');
    /* Ausverkauft entscheidet das Theme ueber die Klasse "disabled" — ein solcher
       Button bleibt in jedem Fall gesperrt, auch nach der Bestaetigung. */
    var soldOut = !!(btn && btn.classList.contains('disabled'));
    var buyable = open && !soldOut;

    if (btn) {
      if (buyable) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    }

    /* Der Hinweis steht in der Box und gilt nur fuer das Gate — bei "ausverkauft"
       waere er irrefuehrend. */
    var hint = gate.querySelector('[data-tp-pv-hint]');
    if (open) { hide(hint); } else { show(hint); }

    var express = form.querySelector('[data-tp-pv-express]');
    if (express) {
      if (buyable) {
        express.classList.remove('is-locked');
        express.removeAttribute('aria-disabled');
      } else {
        express.classList.add('is-locked');
        express.setAttribute('aria-disabled', 'true');
      }
    }
  }

  /* Klick auf einen gesperrten Button landet mangels pointer-events auf der
     umgebenden Zone. Nur dann reagieren, wenn das Ereignis die Zone selbst trifft. */
  function onZoneClick(ev) {
    var zone = ev.currentTarget;
    if (ev.target !== zone) { return; }
    var root = (zone.closest && zone.closest('form')) || document;
    var gates = root.querySelectorAll('[data-tp-pv-gate]'), i, gate;
    for (i = 0; i < gates.length; i++) {
      gate = gates[i];
      if (!isActive(gate) || isConsented(gate)) { continue; }
      ev.preventDefault();
      shake(gate);
      var box = gate.querySelector('[data-tp-pv-consent]');
      if (box) {
        try { box.focus(); } catch (e) { /* aelterer Browser */ }
      }
      return;
    }
  }

  /* Elternelemente der gesperrten Buttons als Klick-Zone binden. */
  function bindZones(root) {
    var els = root.querySelectorAll('[data-tp-pv-locked], [data-tp-pv-express]'), i, zone;
    for (i = 0; i < els.length; i++) {
      zone = els[i].parentNode;
      if (!zone || zone.nodeType !== 1 || zone.tpPvZoneBound) { continue; }
      zone.tpPvZoneBound = true;
      zone.addEventListener('click', onZoneClick);
    }
  }

  /* Variante entscheidet, ob das Gate ueberhaupt gilt. Unbekannte Variante ->
     fail-closed, das Gate bleibt aktiv. */
  function applyVariant(gate, form, variantId) {
    var map = gate.tpPvMap;
    var isPv = true;
    if (map && variantId != null) {
      var hit = map[String(variantId)];
      if (hit === false) { isPv = false; }
    }
    if (isPv) {
      gate.removeAttribute('hidden');
    } else {
      gate.setAttribute('hidden', '');
    }
    applyState(gate, form);
  }

  function currentVariantId(form) {
    var sel = form.querySelector('variant-selection');
    /* Das variant-Attribut ist ab Server-Render gueltig; [name=id] hinkt
       waehrend der Component-Init hinterher (siehe tp-condition-property.js). */
    var initial = sel ? sel.getAttribute('variant') : null;
    if (!initial) {
      var idEl = form.querySelector('[name="id"]');
      initial = idEl ? idEl.value : null;
    }
    return initial;
  }

  function bindProduct(gate) {
    var form = closestForm(gate);
    if (!form) { return; }

    gate.tpPvMap = parseJson(form.querySelector('script[data-tp-pv-variants]'));
    bindZones(form);
    applyVariant(gate, form, currentVariantId(form));

    var sel = form.querySelector('variant-selection');
    if (!sel) { return; }

    /* variant-change bubbelt nicht -> jede Component einzeln binden. */
    sel.addEventListener('variant-change', function (ev) {
      var d = ev.detail || {};
      /* detail.variant ist false, solange der interne Produkt-Fetch der
         Component fehlt; dann traegt detail.state die rohe Varianten-ID. */
      var id = d.variant ? d.variant.id : d.state;
      applyVariant(gate, form, id);
      /* ProductDetails._updateButton() laeuft moeglicherweise nach uns und
         entsperrt den Button -> am Ende des Ticks erneut durchsetzen. */
      setTimeout(function () { applyVariant(gate, form, id); }, 0);
    });
  }

  /* -------------------------------------------------------------- Warenkorb */

  /* Traegt die Bestaetigung an allen betroffenen Zeilen nach. Adressiert wird
     ueber den Line-Item-Key (change.js akzeptiert ihn als id) — Zeilenindizes
     verschieben sich, sobald Shopify eine Zeile mit neuen Properties neu
     einsortiert. Bestehende Properties werden mitgeschickt, sonst geht
     z. B. "Zustand" verloren. Zum Schluss noch das Cart-Attribut, dann Reload. */
  function submitCart(gate) {
    var lines = parseJson(gate.querySelector('script[data-tp-pv-cart-lines]'));
    if (!lines || !lines.length || !window.fetch) { return; }

    var box = gate.querySelector('[data-tp-pv-consent]');
    if (box) { box.disabled = true; }
    gate.setAttribute('data-tp-pv-busy', '');

    var value = stamp(gate);
    var attributes = {};
    attributes[PROPERTY_NAME] = value;
    var i = 0;

    function fail() {
      if (box) { box.disabled = false; box.checked = false; }
      gate.removeAttribute('data-tp-pv-busy');
      shake(gate);
    }

    function finish() {
      window.location.reload();
    }

    function next() {
      if (i >= lines.length) {
        /* Attribut ist die Kuer — der Reload kommt in jedem Fall. */
        postJson('/cart/update.js', { attributes: attributes })
          .then(finish)['catch'](finish);
        return;
      }
      var line = lines[i];
      i += 1;
      var props = line.properties || {};
      props[PROPERTY_NAME] = value;
      postJson('/cart/change.js', {
        id: line.id,
        quantity: line.quantity,
        properties: props
      }).then(function (res) {
        if (!res.ok) { throw new Error('cart/change ' + res.status); }
        next();
      })['catch'](fail);
    }

    next();
  }

  /* ------------------------------------------------------------------ Setup */

  function bindGate(gate) {
    if (gate.hasAttribute('data-tp-pv-bound')) { return; }
    gate.setAttribute('data-tp-pv-bound', '');
    if (mode(gate) === 'cart') {
      bindZones((gate.closest && gate.closest('form')) || document);
      return;
    }
    bindProduct(gate);
  }

  function bindAll() {
    var gates = document.querySelectorAll('[data-tp-pv-gate]'), i;
    for (i = 0; i < gates.length; i++) { bindGate(gates[i]); }
  }

  function observe() {
    if (typeof MutationObserver === 'undefined') { return; }
    var t = null;
    new MutationObserver(function () {
      if (t) { clearTimeout(t); }
      t = setTimeout(bindAll, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-tp-pv-consent')) { return; }
    var gate = t.closest ? t.closest('[data-tp-pv-gate]') : null;
    if (!gate) { return; }

    if (mode(gate) === 'cart') {
      if (t.checked) { submitCart(gate); }
      return;
    }

    var form = closestForm(gate);
    if (!form) { return; }
    applyState(gate, form);
    /* Cart-Attribut zusaetzlich zur Line-Item-Property — Wert wird aus dem
       Property-Input gelesen, damit beide Spuren denselben Zeitstempel tragen.
       Beim Abwaehlen wieder raeumen (Shopify entfernt leere Attribute). */
    var prop = form.querySelector('[data-tp-pv-property]');
    sendAttribute(gate, prop && !prop.disabled ? prop.value : '');
  });

  /* Capture-Phase: greift vor dem submit-Handler der Theme-Komponenten (Ajax-ATC,
     Warenkorb) und damit auch dann, wenn _updateButton() den Button nach einem
     Variantenwechsel wieder aktiviert hat. */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.querySelectorAll) { return; }
    var gates = form.querySelectorAll('[data-tp-pv-gate]'), i, gate;
    for (i = 0; i < gates.length; i++) {
      gate = gates[i];
      if (!isActive(gate)) { continue; }

      if (!isConsented(gate)) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        shake(gate);
        var box = gate.querySelector('[data-tp-pv-consent]');
        if (box) {
          try { box.focus(); } catch (e) { /* aelterer Browser */ }
        }
        return;
      }

      /* Bestaetigt, aber das Cart-Attribut ist noch unterwegs: einmal kurz
         zurueckhalten und nach der Antwort (spaetestens nach dem Timeout)
         selbst erneut absenden. */
      if (gate.tpPvAttrPending && !gate.tpPvResubmit) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        gate.tpPvResubmit = form;
        return;
      }
    }
  }, true);

  if (document.body) {
    bindAll();
    observe();
  } else {
    document.addEventListener('DOMContentLoaded', function () { bindAll(); observe(); });
  }
})();
